import { render, staticRenderFns } from "./GCELanding.vue?vue&type=template&id=0279d2ff&scoped=true&"
import script from "./GCELanding.vue?vue&type=script&lang=js&"
export * from "./GCELanding.vue?vue&type=script&lang=js&"
import style0 from "./GCELanding.vue?vue&type=style&index=0&id=0279d2ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279d2ff",
  null
  
)

export default component.exports